/** @format */

import React, { PureComponent, SyntheticEvent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import MvnoBlockRequest from '../../../interfaces/platform/MvnoBlockRequest';
import green from '@material-ui/core/colors/green';
import deepOrange from '@material-ui/core/colors/deepOrange';
import amber from '@material-ui/core/colors/amber';
import TableCell from '@material-ui/core/TableCell';
import I18n from '../../../components/Translate/I18n';
import { DateHelper } from '../../../helpers/DateHelper';
import TableRow from '@material-ui/core/TableRow';
import { whiteColor } from '../../../assets/jss/material-dashboard-pro-react';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { history } from '../../../core/history';
import AlertInfo from '../../../components/Info/AlertInfo';
import { provActions, provisionigConstants } from '../../../modules/provisioning/action';
import ViewButton from '../../../components/Buttons/ViewButton';
import SimCardButton                           from '../../../components/Buttons/SimCardButton';
import RefreshButton                           from '../../../components/Buttons/RefreshButton';
import CancelButton                            from '../../../components/Buttons/CancelButton';
import PlatformResellerInterface               from '../../../interfaces/platform/PlatformResellerInterface';
import MvnoBlockListInterface                  from '../../../interfaces/platform/MvnoBlockListInterface';
import { brown, lime }                         from '@material-ui/core/colors';
import { BlockViewStateType, LegendMapInt18n } from '../view/BlockViewStateType';
import { operationAction }                     from '../../../modules/block/OperationStatus';
import { roles, UserRoleHelper }               from '../../../helpers/UserRoleHelper';
import oplAppStyle                             from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import COLORS                                  from '../../../assets/themes/OPL/colors';
import GridContainer                           from "../../../components/Grid/GridContainer";
import GridItem                                from "../../../components/Grid/GridItem";

interface MvnoBlockRequestItemProps {
    classes: any;
    dispatch: any;
    item: MvnoBlockRequest;
    platformResellerList: Array<PlatformResellerInterface> | null;
    mvnoBlockList: Array<MvnoBlockListInterface>;

    reloadCallback(): void;

    blockViewState: BlockViewStateType;
    setActiveRow: (id: number) => void;
    rowActiveColor: string;
}

interface MvnoBlockRequestItemState {
    blockId: number | null;
    alert: any | null;
}

class MvnoBlockRequestItem extends PureComponent<MvnoBlockRequestItemProps, MvnoBlockRequestItemState> {
    constructor(props: MvnoBlockRequestItemProps, context: MvnoBlockRequestItemState) {
        super(props, context);
        this.state = {
            alert: null,
            blockId: null,
        };
    }

    callViewDetail = (params: any, event?: SyntheticEvent): void => {
        const uri = FormGeneralHelper.getRouteUrl('/block-request-detail' + params.uri);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(event, uri);
    };

    callViewSimCard = (params: any, event?: SyntheticEvent): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(event, FormGeneralHelper.getRouteUrl('/sim-card-edit' + params.uri));
    };

    callRefreshOperations = (params: any): void => {
        this.setState({
            blockId: params.id,
            alert: (
                <AlertInfo
                    onConfirm={this.callApiCallRefreshOperations}
                    onCancel={this.cancelActivate}
                    confirmBtnText={'simcard:f.save_change'}
                    cancelBtnText={'general:common.cancel'}
                    content="prov:list.confirm_reload_block_operation"
                />
            ),
        });
    };

    callCancel = (params: any): void => {
        this.setState({
            blockId: params.id,
            alert: (
                <AlertInfo
                    onConfirm={this.callApiCallCancel}
                    onCancel={this.cancelActivate}
                    confirmBtnText={'simcard:f.save_change'}
                    cancelBtnText={'general:common.cancel'}
                    content="prov:list.confirm_cancel_block_operation"
                />
            ),
        });
    };

    cancelActivate = (fn: any): void => {
        this.setState({ alert: null, blockId: null }, (): void => {
            fn();
        });
    };

    callApiCallRefreshOperations = (): void => {
        const { blockId } = this.state;
        const params = {
            id: blockId,
            operationType: 1,
        };
        this.callApi(params);
    };

    callApiCallCancel = (): void => {
        const { blockId } = this.state;
        const params = {
            id: blockId,
            operationType: operationAction.OPERATION_CANCEL,
        };
        this.callApi(params);
    };

    callApi = (params: any): void => {
        this.cancelActivate(() => {
            const { dispatch } = this.props;
            dispatch(
                provActions.put(
                    FormGeneralHelper.getUrl('/operation_on_blocks/' + params.id),
                    params,
                    provisionigConstants.OPERTATION_ON_BLOCK,
                    (data: any) => {
                        this.props.reloadCallback();
                    },
                    { propagateDataToCallback: true }
                )
            );
        });
    };

    getPlatformResellerName = (platformResellerId: number): string | null => {
        const { platformResellerList } = this.props;
        if (!platformResellerList) {
            return null;
        }
        for (let i = 0; i < platformResellerList.length; i++) {
            if (platformResellerList[i].id === platformResellerId) {
                return platformResellerList[i].mainname;
            }
        }
        return null;
    };

    getMvnoBlockListName = (mvnoBlockListNameId: number): string | null => {
        const { mvnoBlockList } = this.props;
        if (mvnoBlockList) {
            for (let i = 0; i < mvnoBlockList.length; i++) {
                if (mvnoBlockList[i].id === mvnoBlockListNameId) {
                    return mvnoBlockList[i].blockName;
                }
            }
        }
        return null;
    };

    render(): React.ReactNode {
        const {item, classes, blockViewState, setActiveRow, rowActiveColor} = this.props;
        const {alert} = this.state;
        const tableCellRoot = {root: classes.tableCellRoot};
        const tableStickyCommand = {root: classes.tableStickyCommand};

        let background = COLORS.MAIN.LIGHT;
        if (item.startProcessAt && !item.requestEnd) {
            background = COLORS.ADDITIONAL.ADDITIONAL_2;
        }
        if (item.awaitingRequestId) {
            background = COLORS.ADDITIONAL.ADDITIONAL_1;
        }
        if (item.errorState) {
            background = COLORS.FUNCTION.DANGER;
        }
        if (item.cancel) {
            background = COLORS.ADDITIONAL.ADDITIONAL_5;
        }
        if (item.blockFullyRestarted) {
            background = COLORS.ADDITIONAL.ADDITIONAL_4;
        }
        if (rowActiveColor !== 'white') {
            background = rowActiveColor;
        }

        return (
            <TableRow
                key={'key' + item.id}
                onClick={(): void => {
                    setActiveRow(item.id);
                }}
                hover
            >
                <TableCell classes={tableStickyCommand} align="left">
                    <ViewButton
                        callback={this.callViewDetail}
                        tooltipTitle="prov:list.view"
                        tooltipPlacement="bottom-start"
                        callbackParam={{uri: item['@id']}}
                        key={'detail' + item.id}
                    />
                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_SIMCARD_GET) && (
                        <SimCardButton
                            callback={this.callViewSimCard}
                            tooltipTitle="prov:list.msisdn_view"
                            tooltipPlacement="bottom-start"
                            callbackParam={{ uri: item.simCard }}
                            key={'simcard' + item.id}
                        />
                    )}
                    {UserRoleHelper.checkRole(roles.ROLE_BLOCK_OPERATION_ON_BLOCK) &&
                        item.errorState &&
                        !item.cancel &&
                        !item.blockFullyRestarted && (
                            <RefreshButton
                                callback={this.callRefreshOperations}
                                tooltipTitle="prov:list.call_refresh"
                                tooltipPlacement="bottom-start"
                                callbackParam={{ id: item.id }}
                                key={'refresh' + item.id}
                            />
                        )}
                    {UserRoleHelper.checkRole(roles.ROLE_BLOCK_OPERATION_ON_BLOCK) &&
                        !item.cancel &&
                        !item.blockFullyRestarted &&
                        ((item.errorState && item.requestEnd) || (!item.requestEnd && item.startProcessAt === null)) && (
                            <CancelButton
                                callback={this.callCancel}
                                tooltipTitle="prov:list.call_cancel"
                                tooltipPlacement="bottom-start"
                                callbackParam={{ id: item.id }}
                                key={'cancel' + item.id}
                            />
                        )}
                    {alert}
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    <GridContainer>
                        <GridItem><div style={{backgroundColor: background, width:15, height: 15, borderRadius: '50%',marginRight: 5}}></div></GridItem>
                        <GridItem>{item.id}</GridItem>
                    </GridContainer>
                </TableCell>
                {/*<TableCell classes={tableCellRoot} align="left">*/}
                {/*    {item.mvnoBlockApiRequestId}*/}
                {/*</TableCell>*/}
                {/*{(Auth.isAdminMode() || Auth.isAdminExpertMode()) && (*/}
                <TableCell classes={tableCellRoot} align="left">
                    {item.platformResellerId && this.getPlatformResellerName(item.platformResellerId)}
                </TableCell>
                {/*)}*/}
                <TableCell classes={tableCellRoot} align="left">
                    <I18n trans={'prov:b.' + this.getMvnoBlockListName(item.mvnoBlockListId)} />
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    {item.msisdn}
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    <I18n trans={blockViewState.getState(item)} />
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    {DateHelper.format(item.startRequestDatetime)}
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    {DateHelper.format(item.startProcessAt)}
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    {item.requestEnd && DateHelper.format(item.lastRequestProcessed)}
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    {DateHelper.format(item.createdAt)}
                </TableCell>
            </TableRow>
        );
    }
}

export default compose<any, any>(
    connect((): object => {
        return {};
    }),
    withStyles(oplAppStyle)
)(MvnoBlockRequestItem);
